import React from 'react';
import { MemberCard } from '../../Dashboard/components/Member/MemberCard';
import {
    MTG_PENDING,
    MTG_DECLINED,
    MTG_ATTENDING,
    MTG_TENTATIVE,
} from '../../../../helpers/constants';
import { getAttendeePlaceholderText } from '../../../../helpers/messageText';
import store from '../../../../stores/store';

class Attendee extends React.Component {
    constructor() {
        super();

        this.state = {
            filter: MTG_ATTENDING,
        };
    }

    toggleCollapsed = () => {
        this.setState({ collapsed: !this.state.collapsed });
    };

    toggleFilter = filter => {
        this.setState({ filter: filter });
    };

    getFilteredAttendees = () => {
        const meeting = this.props.meeting;
        const filteredAttendees = meeting.Attendees.filter(attendee => {
            return attendee.AttendanceConstant === this.state.filter;
        });

        filteredAttendees.forEach(attendee => {
            let id = `${meeting.InstanceId}${meeting.GroupId}${meeting.MeetingId}${
                attendee.UserId
            }`;

            attendee.localAvatarUrl = store.meetings.attendeeAvatarUrl[id];
        });

        return filteredAttendees;
    };

    render() {
        const filteredAttendees = this.getFilteredAttendees();

        return (
            <div id="attendees-accordion" role="tablist" aria-multiselectable="true">
                <div
                    id="attendees-content"
                    className="hide collapse show"
                    role="tabpanel"
                    aria-labelledby="headingOne"
                    aria-expanded="true"
                >
                    <div className="pl-2 pr-2 pb-2 pt-0">
                        <div
                            className="mb-2"
                            data-toggle="buttons"
                            role="group"
                            aria-label="Meeting cards options"
                            id="attendee-btn-grp"
                        >
                            <div className="d-flex flex-wrap btn btn-group p-0 mb-2" role="tablist">
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === MTG_ATTENDING ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    aria-pressed="false"
                                    aria-expanded="true"
                                    onClick={() => this.toggleFilter(MTG_ATTENDING)}
                                >
                                    Attending
                                </a>
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === MTG_TENTATIVE ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.toggleFilter(MTG_TENTATIVE)}
                                >
                                    Tentative
                                </a>
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === MTG_DECLINED ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.toggleFilter(MTG_DECLINED)}
                                >
                                    Not attending
                                </a>
                                <a
                                    className={`btn btn-outline-secondary ${
                                        this.state.filter === MTG_PENDING ? 'focus' : ''
                                    }`}
                                    data-toggle="tab"
                                    role="tab"
                                    onClick={() => this.toggleFilter(MTG_PENDING)}
                                >
                                    Yet to respond
                                </a>
                            </div>
                            <div className="tab-content d-flex" id="attendee-list">
                                <div
                                    className="tab-pane w-100 active"
                                    id="attending"
                                    role="tabpanel"
                                >
                                    <div className="d-flex flex-wrap justify-content-center">
                                        <div className="row w-100">
                                            {filteredAttendees.length > 0 ? (
                                                filteredAttendees.map((detail, index) => (
                                                    <MemberCard key={index} detail={detail} />
                                                ))
                                            ) : (
                                                <div className="pl-2">
                                                    {getAttendeePlaceholderText(this.state.filter)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Attendee;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Meeting/components/Attendee.js